import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';

import { oneKlicks } from '../../SDK/oneclick';
import { getSettings } from '../../services/settingsService';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import ImageShow from '../../Uitiles/ImageShow';
import { OneKlicksFileSDK } from '../../SDK/OneKlicksFileSDK';


const SendSmsEmailWhatsapp = () => {
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
    }, [location.search]);


    return (
        <div>
            <h1>Send SMS Email Whatsapp</h1>
        </div>
    );
};

export default SendSmsEmailWhatsapp;    
